import styled from "styled-components";

const LoadingWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #fff;
  opacity: 0.5;
  z-index: 9;

  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export default LoadingWrapper;
